import { render, staticRenderFns } from "./im-alert.vue?vue&type=template&id=a0a1ff38"
import script from "./im-alert.vue?vue&type=script&lang=js"
export * from "./im-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0a1ff38')) {
      api.createRecord('a0a1ff38', component.options)
    } else {
      api.reload('a0a1ff38', component.options)
    }
    module.hot.accept("./im-alert.vue?vue&type=template&id=a0a1ff38", function () {
      api.rerender('a0a1ff38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/component/im-alert.vue"
export default component.exports